var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsDateString, IsNotEmpty, IsString, MaxLength } from "class-validator";
import { safeAssign } from "./safe-assign";
export class UploadWorkerDocumentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    IsNotEmpty(),
    MaxLength(255),
    __metadata("design:type", String)
], UploadWorkerDocumentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UploadWorkerDocumentDTO.prototype, "content", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], UploadWorkerDocumentDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", String)
], UploadWorkerDocumentDTO.prototype, "comment", void 0);
//# sourceMappingURL=upload-worker-document.dto.js.map